import {SUPPORTED_LANGUAGE} from "~core/constants/languange.constants";
// in session viene usato 'clear' per cancellare dal local storage il valore settato

export type LanguageCode = typeof SUPPORTED_LANGUAGE[number];

export function isLanguageCode(value: unknown): value is LanguageCode {
    return (
        typeof value === 'string' &&
        SUPPORTED_LANGUAGE.includes(value as LanguageCode)
    );
}
